// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-icon-arrow[data-v-4dedccba] {\n  color: #fff;\n  font-weight: bold;\n  opacity: 0.8;\n}", ""]);
// Exports
module.exports = exports;
